import React from "react";
import { Text } from "@mantine/core";

export interface DescriptionProps {
  text?: string;
}

const PageTitle = ({ text }: DescriptionProps): React.ReactElement => {
  return (
    <>
      {/* The following Text component is not fully accessible due to insufficient contrast, 
       which may hinder readability for users with visual impairments. */}
      {/* <Text size="xs" c="dimmed">
    {text ?? ""}
  </Text> */}

      {/* This Text component is accessible as it meets contrast requirements, 
       but it lacks styling, which may affect the overall design consistency. */}
      <Text size="xs">{text ?? ""}</Text>
    </>
  );
};

export default PageTitle;
